export default {
  info1: 'This section allows you to configure the access remotely to the platform.',
  info2: 'If you use "Conector Sistema eFactura", you must use the Token access.',
  title: 'API access configuration',
  radioButtons: {
    unauthorized: 'Unauthorized',
    byPassword: 'By Password',
    byKey: 'By Token'
  },
  help: 'Token (file) that will allow you to access the service remotely. This key shall be encrypted with the password and shall be used together with the file in the remote access call',
  accessType: 'Access Type',
  id: '51234567A',
  downloadKey: 'Download Token ',
  identifier: 'Identifier',
  password: 'Password',
  confirmPassword: 'Confirm Password'
}
